import React from "react";

type FormErrorProps = React.PropsWithChildren<{
  className?: string;
  id?: string;
}>;

export function SVVFormError({ children, className, id }: FormErrorProps) {
  return (
    <div className={className} id={id}>
      <div className="svv-form-error">
        {children}
      </div>
    </div>
  );
}

SVVFormError.displayName = "SVVFormError";
